import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getReaderURL } from "../../../bookshelfLinks.ts";
import { AssetLink, SearchLink } from "./types.ts";
import { useLicenseFetcher } from "../../actions/license/licenseLoader.ts";
import { quickSearch, Match } from "./utils.ts";
import { useTimeoutFetcher } from "../common/timeoutLoader.ts";

export default function useTypeahead(
  searchTerm: string
): (AssetLink | SearchLink)[] {
  const licenseFetcher = useLicenseFetcher();
  const timeoutFetcher = useTimeoutFetcher();
  const urlParams = new URLSearchParams();
  urlParams.append("q", searchTerm);
  const navigate = useNavigate();
  const [matches, setMatches] = useState<Match[]>([]);

  useEffect(() => {
    if (licenseFetcher.state === "idle" && !licenseFetcher.data) {
      licenseFetcher.load("/search/api/typeahead");
      timeoutFetcher.load("/search/api/timeout");
    }
  }, [licenseFetcher, timeoutFetcher]);

  useEffect(() => {
    if (searchTerm && licenseFetcher.data?.data) {
      setMatches(quickSearch(licenseFetcher.data.data, searchTerm));
    }
  }, [searchTerm, licenseFetcher.data]);

  return [
    {
      type: "titles",
      term: searchTerm,
      action: () => navigate(`/search/titles?${urlParams.toString()}`),
    },
    {
      type: "book-content",
      term: searchTerm,
      action: () => navigate(`/search/book-content?${urlParams.toString()}`),
    },
    ...(matches.map(({ asset, matchType }) => ({
      asset,
      action: () => window.open(getReaderURL(asset.manageAsset.vbid), "_self"),
      term: searchTerm,
      matchType: matchType,
    })) ?? []),
  ];
}
